import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';
import { formatIQD } from '../../../shared/format.js';

const PALETTE = ['#FF7A1A', '#FFB627', '#06B6D4', '#EC4899', '#22C55E', '#8B5CF6'];

function normalize(data) {
  if (!Array.isArray(data) || !data.length) return [];
  return data.map((d, i) => ({
    name: d.name ?? d.label ?? d.category ?? `قسم ${i + 1}`,
    value: Number(d.value ?? d.amount ?? d.total ?? 0),
    color: d.color || PALETTE[i % PALETTE.length]
  }));
}

export function CategoryDonut({ data }) {
  const rows = normalize(data);
  const total = rows.reduce((s, r) => s + r.value, 0);

  if (!total) {
    return <div className="h-[220px] grid place-items-center text-ink-3 text-xs">لا توجد بيانات بعد</div>;
  }

  return (
    <div className="flex items-center gap-4">
      <div className="relative w-[180px] h-[180px] flex-none">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={rows}
              dataKey="value"
              nameKey="name"
              innerRadius={50}
              outerRadius={78}
              paddingAngle={2}
              stroke="#fff"
              strokeWidth={2}
            >
              {rows.map((r, i) => (
                <Cell key={r.name + i} fill={r.color} />
              ))}
            </Pie>
            <Tooltip
              formatter={(v) => formatIQD(v)}
              contentStyle={{ background: '#fff', border: '1px solid #EFE7D6', borderRadius: 10, fontSize: 12 }}
            />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 grid place-items-center pointer-events-none">
          <div className="text-center">
            <div className="text-[11px] text-ink-3">إجمالي</div>
            <div className="text-[15px] font-bold tracking-tight">{formatIQD(total)}</div>
          </div>
        </div>
      </div>
      <div className="flex-1 flex flex-col gap-2">
        {rows.map((r) => (
          <div key={r.name} className="flex items-center gap-2.5">
            <span className="w-3 h-3 rounded-[3px] flex-none" style={{ background: r.color }} />
            <span className="flex-1 text-[13px] truncate">{r.name}</span>
            <span className="font-bold text-[13px]">{formatIQD(r.value)}</span>
            <span className="text-[11px] text-ink-3 w-9 text-left">
              {Math.round((r.value / total) * 100)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
